import FormStyleEditorButtonPanel from './FormStyleEditorButtonPanel';

export default FormStyleEditorButtonPanel;
